import reset from 'css-wipe/js'
import { injectGlobal } from 'styled-components'

injectGlobal`
  ${ reset }
  html {
    font-size: 16px;
    background: hsl(237, 100%, 4%);
    color: white;
    font-family: Avenir Next, sans-serif;
    font-weight: 400;
  }
  
  @media (max-width: 375px) {
    html {
      font-size: 15px;
    }
  }
  
  @media (min-width: 1280px) {
    html {
      font-size: 18px;
    }
  }
  
  @media (min-width: 1680px) {
    html {
      font-size: 20px;
    }
  }
  
  @keyframes fade-in {
    0% {
      opacity: 0;
    }
  }
  
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
  
    to {
      transform: rotate(90deg);
    }
  }
`



/** WEBPACK FOOTER **
 ** ./src/globalStyles.js
 **/